import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './modal.scss';

type Props = ComponentPropsWithoutRef<typeof Layout>;
export const ModalFixedBottomPanel = ({ children, className, ...props }: Props) => (
    <Layout className={cn('modal__fixed-panel', 'modal__fixed-panel--bottom', className)} {...props}>
        {children}
    </Layout>
);
